import { NgModule } from '@angular/core';
import { ScrollStateDirective } from './scroll-state.directive';

@NgModule({
  declarations: [ScrollStateDirective],
  exports: [ScrollStateDirective],
})
export class ScrollStateModule {}
